<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('studentScoringEntry.dayAbsent')
          }}</label>
          <input type="number" v-model.number="model.day_absent" class="form-control" :class="{ 'is-invalid': errors.has('day_absent') }" />
          <div class="validate" v-if="errors.has('day_absent')">
            {{ errors.first('day_absent') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click="onCloseModal">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            color="primary"
            :waiting="waiting"
            @click.prevent="onSave"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'advisorComment',
  props: ['value'],
  components: { VueEditor },
  data() {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      model: {
        sc_stu_com_id: 0,
        student_id: null,
        class_id: null,
        scoring_cycle_id: null,
        cycle_value: null,
        day_absent: null
      }
    }
  },
  created() {
    this.model.student_id = this.value.student_id
    this.model.class_id = this.value.class_id
    this.model.scoring_cycle_id = this.value.scoring_cycle_id
    this.model.cycle_value = this.value.cycle_value
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/findComment', {
          params: {
            student_id: this.value.student_id,
            st_class_id: this.value.st_class_id,
            scoring_cycle_id: this.value.scoring_cycle_id,
            cycle_value: this.value.cycle_value,
          },
        })
        .then((response) => {
          if (response.data) {
            this.model.sc_stu_com_id = response.data.sc_stu_com_id
            this.model.day_absent = response.data.day_absent
          }
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('studentScoringEntry/saveDayAbsent', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$emit('closeModal')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onCloseModal() {
      this.clearInput()
      this.$emit('closeModal')
    },
    clearInput() {
      this.model.sc_stu_com_id = 0
      this.model.student_id = null
      this.model.class_id = null
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.model.day_absent = null
    },
  },
}
</script>
